import styled from "styled-components";

export const Container = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  background-color: transparent;
  cursor: pointer;
`;
export const Text = styled.p`
  color: #333333;
`;
export const Circle: any = styled.div`
  height: 18px;
  width: 18px;
  border-width: 1px;
  border-style: solid;
  border-color: ${(props: any) => (props.isSelected ? "#4a76fb" : "#c0c0c0")};
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InnerCircle: any = styled.div`
  height: 10px;
  width: 10px;
  background-color: ${(props: any) =>
    props.isSelected ? "#4a76fb" : "#c0c0c0"};
  border-radius: 5px;
`;
